export default __webpack_public_path__ + "static/media/big-plus.b3bb0c39.svg";